import { createWebHistory, createRouter } from 'vue-router'

const Frontpage = () => import('./components/Frontpage.vue')
const Article = () => import('./components/Article.vue')
const About = () => import('./components/About.vue')
const Tip = () => import('./components/Tip.vue')
const Search = () => import('./components/Search.vue')
const Support = () => import('./components/Support.vue')
const Ethics = () => import('./components/Ethics.vue')
const ContentUsage = () => import('./components/ContentUsage.vue')
const Gdpr = () => import('./components/Gdpr.vue')
//const dveDane = () => import('./components/2dane.vue')
const dvePercenta = () => import('./components/DvePercenta.vue')

const router = createRouter({
    // use browser history for an SPA so navigation updates the URL and works with the dev server
    // createMemoryHistory keeps navigation in-memory (no address bar updates) — use web history
    history: createWebHistory(),
    routes: [
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/search/:search',
            name: 'Search',
            component: Search
        },
        // article routes that start with an numeric id, e.g. /226/Podporte-nas
        {
            path: '/:id(\\d+)/:slug(.*)?',
            name: 'Article',
            component: Article,
            props: true
        },
        {
            path: '/tip',
            name: 'Tip',
            component: Tip
        },
        {
            path: '/support',
            name: 'Support',
            component: Support
        },
        {
            path: '/ethics',
            name: 'Ethics',
            component: Ethics
        },
        {
            path: '/content-usage',
            name: 'ContentUsage',
            component: ContentUsage
        },
        /*
        {
          path: '/2-percenta-dani',
          name: '2dane',
          component: dveDane
        },*/
        {
            path: '/darujte-2-percenta',
            name: 'DvePercenta',
            component: dvePercenta
        },
        {
            path: '/gdpr',
            name: 'Gdpr',
            component: Gdpr
        },
        {
            path: '/article-test/:articleUID',
            name: 'Test článkov',
            props: true,
            component: Article
        },
        {
            // catch-all -> frontpage
            path: '/:pathMatch(.*)*',
            name: 'Frontpage',
            component: Frontpage
        }
    ]
})

export default router
